// extracted by mini-css-extract-plugin
export default {"subtitle":"ProTrialUsed_subtitle__-idfc","proTrialUsed":"ProTrialUsed_proTrialUsed__6IYPM"};